export { default } from './TherigyLoadingSpinner';
